import { useEffect, useState } from 'react'
import useUnreadMessagesContext from '@contexts/unreadMessagesContext'
import useConversationsContext from '@contexts/conversationsContext'
import useScrollTriggerContext from '@contexts/scrollTriggerContext'
import useLocalState from '@hooks/useLocalState'
import ConversationsTopNav from '@components/conversations/ConversationsTopNav'
import ConversationList from '@components/conversations/ConversationList'
import SwipeableViews from 'react-swipeable-views'
import ScreenContainer from './ScreenContainer'

const Messages = () => {
  const { userReadMessages, addSeenMessage } = useUnreadMessagesContext()
  const { allConversationData, favoriteConversationData } = useConversationsContext()
  const [selectedItem, setSelectedItem] = useLocalState('selected-conversation-tab', 0)
  // Local Scroll Trigger
  const [scrollTarget, setScrollTarget] = useState(undefined)
  // // Global Scroll Trigger
  const { useScrollTriggerEffect } = useScrollTriggerContext()
  useScrollTriggerEffect(scrollTarget)
  
  // Causes top and bottom bar to come back into view when we swipe to another conversation
  useEffect(() => setScrollTarget(false), [selectedItem])

  // sets unread messages to false, and adds all conversations seen to read conversations
  useEffect(() => {
    userReadMessages()
    allConversationData.items.forEach((convo) => {
      if (convo.uuid && convo?.mostRecentMessage?.uuid) {
        addSeenMessage(convo.uuid, convo?.mostRecentMessage?.uuid)
      }
    })
  }, [])

  return (
    <>
      <ConversationsTopNav
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
      />
      <ScreenContainer>
        <SwipeableViews
          onChangeIndex={(i) => setSelectedItem(i)}
          index={selectedItem}
          enableMouseEvents
          axis='x'>
          <ConversationList
            conversationData={allConversationData}
            setScrollTarget={setScrollTarget}
            currentTab={selectedItem}
            uniqueTab={0}
          />
          <ConversationList
            conversationData={favoriteConversationData}
            setScrollTarget={setScrollTarget}
            currentTab={selectedItem}
            uniqueTab={1}
          />
        </SwipeableViews>
      </ScreenContainer>
    </>
  )
}

export default Messages
